import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { BASE_URL, ADD_UPDATE_COMPANY_GROUP, ADD_UPDATE_MEMBER_COMPANY, ADD_UPDATE_GROUP } from "../constants";
import { getUserToken } from "../utilityFunctions/localServices";

export const orgGroupAddUpdate = createApi({
  reducerPath: "orgGroupAddUpdate",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  endpoints: (builder) => ({
    orgGroupAddUpdate: builder.mutation({
      query: ({ token, data }) => ({
        url: `${ADD_UPDATE_COMPANY_GROUP}`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }),
    }),
  }),
});

export const { useOrgGroupAddUpdateMutation } = orgGroupAddUpdate;

export const orgGroupAddUpdateMember = createApi({
  reducerPath: "orgGroupAddUpdateMember",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  endpoints: (builder) => ({
    orgGroupAddUpdateMember: builder.mutation({
      query: ({ token, data }) => ({
        url: `${ADD_UPDATE_MEMBER_COMPANY}`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }),
    }),
  }),
});

export const { useOrgGroupAddUpdateMemberMutation } = orgGroupAddUpdateMember;
